import { CloseRounded } from "@mui/icons-material";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Row from "../components/row";
import { Button } from "../models/post";
import InfoStyle from "./info-style";
import { Wrapper } from "./post-components";
import { DeleteButton } from "./text-component";

const ButtonStyle = styled.div`
    border-radius: 0.6rem;
    background: #77992c;
    display: inline-block;
    padding: 0.15rem 0.7rem;
    color: white;
    font-size: 25px;
    line-height: 35px;
    cursor: pointer;
    text-align: center;
`;

const ButtonWrapper = styled.div`
    position: relative;
    display: grid;
    gap: 1rem;
`;

export default function ButtonComponent(props: { button: Button, update: (label: string, link: string) => void, deleteContent: () => void }) {
    const [label, setLabel] = useState(props.button.label);
    const [link, setLink] = useState(props.button.link);
	const [showDelete, setShowDelete] = useState(false);

    useEffect(() => {
        props.update(label, link);
    }, [label, link, props]);
    return <ButtonWrapper onMouseMove={() => setShowDelete(true)} onMouseEnter={() => setShowDelete(true)} onMouseLeave={() => setShowDelete(false)}>
        <DeleteButton onClick={props.deleteContent} show={showDelete}>
            <CloseRounded />
        </DeleteButton>
        <div style={{ textAlign: "center" }}>
            <ButtonStyle>
                {label === "" ? "Button" : label}
            </ButtonStyle>
        </div>
        <Row>
            <Wrapper>
                <InfoStyle value={label} onChange={e => setLabel(e.target.value)} placeholder="Text" />
            </Wrapper>
            <Wrapper>
                <InfoStyle value={link} onChange={e => setLink(e.target.value)} placeholder="Link" />
            </Wrapper>
        </Row>
    </ButtonWrapper>
}